import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormApi } from 'final-form';

import { useCampaignUpdateMutation } from '@occc-app/dataAccessLayer/campaign/mutations';
import { useGetCampaignById } from '@occc-app/dataAccessLayer/campaign/queries';
import { CampaignFormValues } from '@occc-app/routes/Campaign/types';
import { validateCampaign } from '@occc-app/routes/Campaign/validation';
import { UpdateCampaignPage } from '@occc-app/routes/Campaign/CampaignUpdatePage/UpdateCampaignPage';
import { CampaignUpdateMutation } from '@occc/graphql';

import { routeCreator } from '../utils';

export const UpdateCampaignPageContainer: React.FC = () => {
  const navigate = useNavigate();
  const { id: campaignId = '' } = useParams<{ id: string }>();
  const { loading, error, data, loaded } = useGetCampaignById(campaignId);
  const initialValues = {
    name: data?.name || '',
    description: data?.description || undefined,
    category: data?.category || undefined,
    externalId: data?.externalId || undefined,
  };

  const onCompleted = (mutation: CampaignUpdateMutation) => {
    navigate(routeCreator.details(mutation.campaignUpdate.uuid));
  };

  const [campaignUpdateMutation] = useCampaignUpdateMutation({ onCompleted });
  const campaignUpdate = (values: CampaignFormValues, form: FormApi<CampaignFormValues>) => {
    const dirtyFields = Object.keys(form.getState().dirtyFields);
    const input = dirtyFields.reduce((accumulator, currentValue) => {
      accumulator[currentValue] = (values as any)[currentValue]
        ? (values as any)[currentValue]
        : null;
      return accumulator;
    }, {} as any);
    return campaignUpdateMutation({
      variables: {
        input: {
          uuid: campaignId,
          ...input,
        },
      },
    });
  };

  return (
    <UpdateCampaignPage
      campaignUpdate={campaignUpdate}
      initialValues={initialValues}
      validate={validateCampaign}
      campaignId={campaignId}
      loading={loading}
      loaded={loaded}
      error={error}
    />
  );
};
